import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import * as headers from '@/helpers/headers';
import Vue from 'vue';
const state = {
  loading: false,
};

const getters = {
  getCacheLoading: (state) => state.loading,
};

const actions = {
  async clearCacheGroup({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      commit('SET_CACHE_LOADING', true);
      axios
        .get(
          process.env.VUE_APP_CLEAR_CACHE_GROUP,
          headers.createHeaders(rootState.user.token, 'abdulNewswav')
        )
        .then((res) => {
          commit('SET_CACHE_LOADING', false);
          Vue.$toast.open({
            message: `Cleared cache and broadcasted`,
            type: 'success',
            position: 'top-right',
          });
          resolve(res);
        })
        .catch((err) => {
          Vue.$toast.open({
            message: `Failed to clear cache`,
            type: 'error',
            position: 'top-right',
          });
          reject(err.response.data.message);
          Bugsnag.notify(err);
          commit('SET_CACHE_LOADING', false);
        });
    });
  },
};

const mutations = {
  SET_CACHE_LOADING: (state, val) => (state.loading = val),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
